<template>
    <div class="active">
        <el-card shadow = "never">
            <!-- <el-row>
                <el-col :span="10" :offset="1">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <el-form-item
                            label="券号"
                            prop="voucherCode"
                        >
                            <el-col :span="24">
                                <el-input v-model="ruleForm.voucherCode.value1"></el-input>
                            </el-col>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form 
                            :model="ruleForm" 
                            :rules="rules" 
                            ref="ruleForm"
                            label-width="80px"
                            class="demo-ruleForm"
                            >   
                            <el-form-item
                                label="券号 :"
                                prop="voucherCode"
                            >
                                <el-col :span="24">
                                    <el-input v-model="ruleForm.voucherCode.value1" :maxlength ="8"></el-input>
                                </el-col>
                            </el-form-item>
                            
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                                <el-button @click="cancel">返回</el-button>
                            </el-form-item>
                        </el-form> 
                    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
                         
                        <!-- <el-form-item label="券号 :">
                            <el-input v-model="formLabelAlign.code" readonly></el-input>
                        </el-form-item> -->
                        <el-form-item label="类型名称 :">
                            <el-input v-model="formLabelAlign.type" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="单价 :">
                            <el-input v-model="formLabelAlign.price" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="销售地点 :">
                            <el-input v-model="formLabelAlign.location" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="免费招待 :">
                            <el-input v-model="formLabelAlign.complimentary" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="状态 :">
                            <el-input v-model="formLabelAlign.status" readonly></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    data(){
        var validatorQty = (rule,value,callback) => {
            if(value.value1 != ''){
                let value1 = this.trim(value.value1);
                if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value1) == false ){
                    callback(new Error("请填写大于0的数字"));
                }else if(/[+]/g.test(value.value1)){
                    //console.log('包含加号')
                    callback(new Error("请输入大于0的数字"));
                }else if(value.value1.length != 8){
                    // console.log('券号不为8位数字')
                    callback(new Error("请输入8位数的券号！"));
                }else{
                    callback();
                }
            }else{
                callback(new Error("至少输入一个券号！"));
            }
        }
        return {
           ruleForm:{
                voucherCode:{
                    value1:"",
                    // value2:""
                },
            }, 
            rules:{
                voucherCode: [
                    { validator : validatorQty,required: true,trigger:'blur',type:'number'},
                    // { message: '请填写券号', trigger: 'blur' }
                ]
            },
            labelPosition: 'right',
            formLabelAlign: {
                //code: '',
                type: '',
                price: '',
                location: '',
                complimentary: '',
                status: ''
            },
            readonly : true 
        }
    },
    created (){
       
    },
    methods:{
        //确认券号信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                let { voucherCode } = this.ruleForm ;
                let value = this.trim(voucherCode.value1);
                 let userId = sessionStorage.getItem("userId") ;
                if (valid) {
                    let params = {
                        act : 'checks',
                        code : value,
                        userId
                    }
                    this.formLabelAlign = {} ;
                    this.findType(params).then((res) =>{
                        // console.log(res)
                        if(res.data.status == true){
                            let result = res.data.data ;
                            let { complimentary , status} = result ;
                            if(complimentary == "N"){
                                complimentary ="否"
                            }else if(complimentary == "Y"){
                                complimentary ="是"
                            }else if(complimentary == "null"){
                                complimentary =""
                            }
                            // complimentary ="N" ? '否' :'是';
                            let newStatus = this.formalStatus(status);
                            this.formLabelAlign = result ;
                            this.formLabelAlign.complimentary = complimentary ;
                            this.formLabelAlign.status = newStatus ;
                        }else{
                            this.alert('查找不到此券！','warning')
                        }
                    }).catch((error) => {
                        this.alert('校验时请求不到数据','error')
                    })
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },

        //格式化 状态
        formalStatus(status){
            let newStatus ;
            switch(status){
                case "G" :
                    newStatus = '生成' ;
                break ;
                case "C" :
                    newStatus = '确认' ;
                    break ;
                case "D" :
                    newStatus = "分配" ;
                    break;
                case "A" :
                    newStatus = "激活" ;
                    break;
                case "S" :
                    newStatus = "销售" ;
                    break;
                case "R" :
                    newStatus = "核销" ;
                    break;
                case "M" :
                    newStatus = "调整" ;
                    break;
            }
            return newStatus ;
        }
    }
}
</script>
